/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useEffect, useState } from 'react';
import { vappContainer } from '@/application';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';

import { LandingPage as LandingPageWidget } from '@widgets/landing-page-widget';

import { useTheme } from '@providers/theme';
import { useSMGetProductPageData } from '@pages/ProductPage/machines';
import { ProductPageService } from '@pages/ProductPage/services';

const getSrv = () => {
  return vappContainer.get<ProductPageService>(ProductPageService.displayName);
};

export const ContainerComm = (props: any) => {
  const [buttonItem, setButtonItem] = useState<any>([]);
  const theme = useTheme();
  const srv = getSrv();

  useEffect(() => {
    async function getNavItems() {
      let _navlinks = await srv?.agent?.getHeaderNavContent();
      if (_navlinks) {
        setButtonItem(_navlinks);
      }
    }
    setTimeout(() => {
      getNavItems();
    }, 500);
  }, []);

  const {
    getProductPageDataMachine,
    getProductPageDataMachineSend,
    getProductPageDataMachineState,
  } = useSMGetProductPageData({});

  const _renderPage = () => {
    if (getProductPageDataMachineState?.matches('RENDER_PRODUCT_PAGE_DATA')) {
      return (
        <>
          <LandingPageWidget
            {...(getProductPageDataMachineState?.event?.data?.value || {})}
            secondaryColor={theme?.colors?.secondary}
            buttonItem={buttonItem}
          />
        </>
      );
    }
    if (getProductPageDataMachineState?.matches('GET_PRODUCT_PAGE_DATA')) {
      return (
        <StateOSD
          {...(srv?.agent?.getLoadingContentSync()?.loading?.pageLoading || {})}
        />
      );
    }
  };
  return <>{_renderPage()}</>;
};
